import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const EventList = (props) => {
 
    const [events, setEvents] = useState([]);
    const [filter, setFilter] = useState("all");
    const [filteredEvents, setFilteredEvents] = useState([]);

    useEffect(() => {
      const now = new Date();
      apiGet(`intranetevents/getallevents`).then(res => {
        res.json().then(data => {
            setEvents(data.results)
            setFilteredEvents(data.results.filter(event => {
              const date = new Date(event.starttime);
              if(date > now){
                return event
              }
            }))
        })
        })
    }, [])

    useEffect(() => {
      if(filter === "all"){
        const now = new Date();
        setFilteredEvents(events.filter(event => {
          const date = new Date(event.starttime);
          if(date > now){
            return event
          }
        }))
      }

      if(filter === "past"){
        const now = new Date();
        setFilteredEvents(events.filter(event => {
          const date = new Date(event.starttime);
          if(date < now){
            return event
          }
        }).sort((a, b) => {
          const aDate = new Date(a.starttime);
          const bDate = new Date(b.starttime);
          return bDate - aDate;
        }))
      }

      if(filter === "speed networking"){
        setFilteredEvents(events.filter(event => {
          if(event.eventtype === 7){
            return event
          }
        }))
      }

      if(filter === "weekly networking"){
        setFilteredEvents(events.filter(event => {
          if(event.eventtype === 8){
            return event
          }
        }))
      }

      if(filter === "linkedin pods"){
        setFilteredEvents(events.filter(event => {
          if(event.eventtype === 9){
            return event
          }
        }))
      }

      if(filter === "face networking"){
        setFilteredEvents(events.filter(event => {
          if(event.eventtype === 5){
            return event
          }
        }))
      }

      if(filter === "sweat membership"){
        setFilteredEvents(events.filter(event => {
          if(event.eventtype === 6){
            return event
          }
        }))
      }
    }, [filter])


    const updateEvent = (e) => {
        console.log("u")
        props.setUpdateOrCreate("u")
        props.setId(e.target.value)
    }

    const createEvent = () => {
      props.setUpdateOrCreate("c")
  }

  const deleteEvent = (e) => {
    console.log(e.target.value)
    apiDelete(`intranetevents/deleteevent`, {id: e.target.value})
  .then(response => {if(response.ok){
    
    apiGet(`intranetevents/getallevents`).then(res => {
        res.json().then(data => {
          const now = new Date();
            setEvents(data.results)
            setFilteredEvents(data.results.filter(event => {
              const date = new Date(event.starttime);
              if(date > now){
                return event
              }
            }))
        })
        })
  }
  })
}

    return (
        <>
          <Container>
            <Row>
                <h1>Events</h1>
            </Row>
            <Row>
                <Col>
                    <Form>
                    <a href={`https://business-butler-intranet.herokuapp.com/`} className="btn btn-primary">
                        Home Page
                    </a>
                    <Button onClick={(event) => createEvent(event)} className="btn btn-primary">
                        Create New
                    </Button>
                    <a href={`/event-tag-management`} className="btn btn-primary">
                    Event Tag Management
                  </a>
                    </Form>
                </Col>
            </Row>
            <Row>
            <Form.Group controlId="exampleForm.ControlSelect1">
                    <Form.Label>Filter</Form.Label>
                    <Form.Control onChange={(event) => setFilter(event.target.value)} as="select" value={filter}>
                      <option value="all">All upcoming</option>
                      <option value="past">Past Events</option>
                      <option value="weekly networking">Weekly Networking</option>
                      <option value="speed networking">Speed Networking</option>
                      <option value="face networking">Face to Face Networking</option>
                      <option value="linkedin pods">Linkedin Pods</option>
                      <option value="sweat membership">Sweat your BB membership</option>
                    </Form.Control>
                  </Form.Group>
            </Row>
                <div className="section">
                  {filteredEvents.map(event => {
                    const date = new Date(event.starttime)
                    return (
                      <Row style={{paddingBottom:"10px"}}>
                          
                          <Col md={2}>{event.id}</Col>
                          <Col md={4}>{event.title}</Col>
                          <Col md={3}>{date.toLocaleString('en-GB')}</Col>
                          <Col md={3}>
                            <Button onClick={(e) => updateEvent(e)} value={event.id} className="btn btn-primary">
                              Edit
                            </Button>
                            <Button onClick={(e) => deleteEvent(e)} value={event.id} className="btn btn-primary">
                              Delete
                            </Button>
                          </Col>
                      </Row>
                      
                    )
                  })}
                </div>
            
            </Container>
        </>
      );

}

export default EventList;